/**
 * generalDataSync — tiny write-sequence guard for the general_data slice.
 *
 * The tab-description screens fetch their intro on mount and save inline
 * (InAppDescriptionPanel). A slow mount fetch can resolve AFTER a save
 * and dispatch FETCH_ALL_GENERAL_DATA with pre-save text, reverting the
 * Redux baseline the panel compares against (Save re-enables, Discard
 * would restore stale content).
 *
 * Rule: every successful general_data write bumps the sequence; fetch
 * thunks capture the sequence before their request and drop the response
 * if a write happened while it was in flight. The next mount refetches,
 * so nothing is ever permanently skipped.
 */
let writeSeq = 0;

export function markGeneralDataWrite() {
  writeSeq += 1;
}

export function getGeneralDataWriteSeq() {
  return writeSeq;
}
